import React from "react";
import { Addresses } from "utils/Addresses";
interface Props {
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDrawerOpen: boolean;
}

const DashboardHeader: React.FC<Props> = ({
  setIsDrawerOpen,
  isDrawerOpen,
}) => {
  return (
    <div className="dashboard-header">
      <img
        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
        src={Addresses.icons.TOGGLE_SIDE_MENU}
      />
      <a title="home.delta.ir" href="https://home.delta.ir/" target="_blank">
        <img src={Addresses.icons.HOME} />
        To Delta Home
      </a>
    </div>
  );
};

export default DashboardHeader;
